import Component from '../../components/component/component';

import './gif.scss';

import './import/kvartal-nimed-roh.gif';
import './import/kvartal-nimed-roosa.gif';

export default class Gif extends Component {
    static initSelector: string = '.js-gif';

    imgElement: JQuery;

    constructor(target: HTMLElement) {
        super(target);

        this.imgElement = this.element.find('.gif__gif');

        this.init();
    }

    init(): void {
        setTimeout(() => {
            this.srcHandler();
        }, 100);
        $(window).on('scroll.srcHandler', this.srcHandler.bind(this));
    }

    srcHandler(): void {
        if (this.imgElement.hasClass('is-in-viewport')) {
            const src: string = this.imgElement.data('src');

            this.imgElement.attr('src', src);

            $(window).off('scroll.srcHandler');
        }
    }
}

